import SFAuthService, { NO_USER } from '../SFAuthService'

interface RecordToDelete {
  Id: string
}

/**
 * Calls flow that operates on 'toDelete' variable by provided name
 * @function
 * @category Salesforce
 * @param {string} flowName Name of the flow to be called.
 * @param {RecordToDelete[]} records Records to be deleted.
 * @returns {JSForceResult}
 */
export const callDeleteFlow = (flowName: string, records: RecordToDelete[]) => {
  const conn = SFAuthService.getConnection()
  if (!conn) {
    return Promise.reject(NO_USER)
  }

  return conn.requestPost(`/actions/custom/flow/${flowName}`, {
    inputs: [
      {
        toDelete: records
      }
    ]
  })
}

export const enforceQuerySuccess = async (
  query: () => Promise<any>,
  repeatsBeforeFail: number = Infinity,
  timeoutMs: number = 5000
): Promise<any> => {
  let failCount = 0

  const executeQuery = async (): Promise<any> => {
    return await query().then(
      (result) => {
        return result
      },
      async (error) => {
        failCount++
        return await new Promise((resolve, reject) => {
          if (failCount <= repeatsBeforeFail) {
            setTimeout(() => {
              resolve(executeQuery())
            }, timeoutMs)
          } else {
            reject(error)
          }
        })
      }
    )
  }

  return await executeQuery()
}
